import { $, findTarget } from '../utils/Utils';

const expand = (() => {
  let triggers;
  const triggersCN = '.js-expandTrigger';
  const parent = 'js-expandParent';
  const targetCN = 'js-expandTarget';
  const activeCN = '-active';

  const compactTarget = ({ trigger, target }) => {
    // update trigger text
    trigger.innerHTML = trigger.dataset.compact;
    // hide target
    target.classList.add(activeCN);
  };

  const expandTarget = ({ trigger, target }) => {
    // update trigger text
    trigger.innerHTML = trigger.dataset.expand;
    // show target
    target.classList.remove(activeCN);
  };

  const toggleTarget = ({ trigger, target }) => {
    (target.classList.contains(activeCN)) ?
      expandTarget({ trigger, target })
      : compactTarget({ trigger, target });
  };

  const handleClick = (trigger) => {
    const target = findTarget({ element: trigger, parent, target: targetCN });

    // handleClick
    trigger.addEventListener('click', () => {
      toggleTarget({ trigger, target });
    });
  };

  const build = () => {
    triggers.forEach((trigger) => {
      handleClick(trigger);
    });
  };

  const init = () => {
    triggers = [...$(triggersCN)];

    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default expand;



// WEBPACK FOOTER //
// ./components/expand.js